<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.098"
    height="12.038"
    viewBox="0 0 21.098 12.038"
  >
    <path
      d="M20.969,63.732,12.907,52.983a.644.644,0,0,0-1.031,0L8.534,57.439,7.207,55.67a.644.644,0,0,0-1.031,0L.129,63.732a.644.644,0,0,0,.515,1.031H20.454a.644.644,0,0,0,.515-1.031ZM1.933,63.474,6.691,57.13,8.018,58.9a.644.644,0,0,0,1.031,0l3.342-4.457,6.773,9.031Z"
      transform="translate(0 -52.725)"
    />
  </svg>
</template>
